import { PmrClassification } from '../../../models/PmrClassification';

export const buildPmrOptions = (t) => {
  return [
    {
      id: 1,
      label: t('satisfactory'),
      value: PmrClassification.Green,
    },
    {
      id: 2,
      label: t('alert'),
      value: PmrClassification.Yellow,
    },
    {
      id: 3,
      label: t('problem'),
      value: PmrClassification.Red,
    },
    {
      id: 4,
      label: t('not_assigned'),
      value: PmrClassification.Na,
    },
  ];
};

export const buildPmrIdInitial = () => {
  return [
    { PmrClassification: PmrClassification.Green, selected: false },
    { PmrClassification: PmrClassification.Yellow, selected: false },
    { PmrClassification: PmrClassification.Red, selected: false },
    { PmrClassification: PmrClassification.Na, selected: false },
  ];
};
